import { Component, OnInit, OnDestroy } from '@angular/core';
import { Field } from 'ng-formly';
import * as _ from 'lodash';
import { PlatformApp } from '../../services/app.service';

@Component({
    selector: 'formly-datepicker',
    template: ` 
  <div class="form-group">
    <div class="input-group">
      <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [formControl]="formControl">
      <div class="input-group-addon" (click)="toggle()" >
        <i class="fa fa-calendar"></i> 
      </div>
    </div>
  </div>
  `,
})
export class DatePicker extends Field implements OnInit, OnDestroy {

    subscriptions: any = [];
    formulae = [];
    modelValues = [];

    ngOnInit() {

        if (!this.form['newcontrols']) { this.form['newcontrols'] = {}; }

        for (let key in this.form.controls) {
            this.form['newcontrols'][key] = this.form.controls[key];
        }

        if (this.field['formulae']) {
            this.formulae = this.field['formulae'];

            // Create Form level Array
            if (!this.form['subscribed']) { this.form['subscribed'] = []; }

            // Subscription for Current Field
            if (this.field.formControl) {
                if (!_.includes(this.form['subscribed'], this.field.key)) {
                    this.form['subscribed'].push(this.field.key);
                    this.addWatcher(this.field.formControl);
                }
            } else { console.log('Missing DateField : ' + this.field.key); }

        }
    }

    toggle() {
        this.field.templateOptions.isOpen = !this.field.templateOptions.isOpen;
    }

    private addWatcher(formControl) {
        this.subscriptions.push(formControl.valueChanges.subscribe((updatedValue: any) => {
            for (let i = 0; i < this.formulae.length; i++) {
                let formula = this.formulae[i];
                if (this.setModelValues(formula['fields'], updatedValue)) {
                    this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
                }
            }
        }));
    }

    private setModelValues(fieldArray, updatedValue) {
        let requiredFieldsExist = true;
        this.modelValues = [];
        for (let j = 0; j < fieldArray.length; j++) {
            if (!this.model[fieldArray[j]]) {
                requiredFieldsExist = false;
            } else {
                if (fieldArray[j] == this.field.key) {
                    this.modelValues.push(updatedValue);
                } else {
                    this.modelValues.push(this.model[fieldArray[j]]);
                }
            }
        }
        return requiredFieldsExist;
    }

    private setResults(resultArray, value): void {
        for (let i = 0; i < resultArray.length; i++) {
            let resultField = resultArray[i];
            if (this.form.controls[resultField]) {
                this.form.controls[resultField].setValue(value);
            } else {
                if (this.form['newcontrols'][resultField]) {
                    this.form['newcontrols'][resultField].setValue(value);
                } else {
                    this.model[resultField] = value;
                }
            }
        }
    }

    ngOnDestroy() {
        for (let i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/datepicker.ts